import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import { useActiveGithubOrgForUser, useConnectedGithubOrgs } from "@/hooks/useConnectedGithubOrgs";
import { getSidebarLayout } from "@/components/SidebarLayout";
import WelcomeDialog from "@/components/WelcomeDialog";
import { Dv360FloodlightAppLpConversion } from "@/components/marketing/Dv360FloodlightAppLpConversion";
import { useSearchParams } from "next/navigation";
export default function Index() {
  const $ = _c(11);
  const router = useRouter();
  const searchParams = useSearchParams();
  const {
    activeGithubOrg,
    codesmithEnabled
  } = useActiveGithubOrgForUser();
  const {
    connectedGithubOrgs
  } = useConnectedGithubOrgs();
  const hasNavigated = useRef(false);
  let t0;
  let t1;
  if ($[0] !== activeGithubOrg || $[1] !== codesmithEnabled || $[2] !== router || $[3] !== searchParams) {
    t0 = () => {
      if (activeGithubOrg && !hasNavigated.current) {
        hasNavigated.current = true;
        const params = new URLSearchParams(searchParams.toString());
        const landing = params.get("landing");
        params.delete("landing");
        const queryString = params.toString();
        const isMobile = window.matchMedia("(max-width: 767px)").matches;
        const basePath = codesmithEnabled ? landing === "codesmith" ? `/${activeGithubOrg}/sessions` : isMobile ? `/${activeGithubOrg}/sessions/new` : `/${activeGithubOrg}` : `/${activeGithubOrg}`;
        const newPath = `${basePath}${queryString ? `?${queryString}` : ""}`;
        router.replace(newPath, undefined, {
          shallow: true
        });
      }
    };
    t1 = [activeGithubOrg, codesmithEnabled, router, searchParams];
    $[0] = activeGithubOrg;
    $[1] = codesmithEnabled;
    $[2] = router;
    $[3] = searchParams;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Dv360FloodlightAppLpConversion />;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== connectedGithubOrgs?.installations.length) {
    t3 = connectedGithubOrgs?.installations.length ? null : <WelcomeDialog />;
    $[7] = connectedGithubOrgs?.installations.length;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <>{t2}<div className="flex items-center justify-center h-64"><div className="text-center">{t3}</div></div></>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
Index.getLayout = getSidebarLayout;